jQuery(document).ready(function () {
	jQuery('body').append(`<div class="popup-video"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
	<rect x="1.75769" width="24.8575" height="2.48575" transform="rotate(45 1.75769 0)" fill="#F5F5F2"/>
	<rect x="19.335" y="1.75781" width="24.8575" height="2.48575" transform="rotate(135 19.335 1.75781)" fill="#F5F5F2"/>
	</svg><div class="video-box"><div class="video-bg"></div></div></div>`);
	faqs();
	videoSlider();
	plansSlider();
	videoPopup();
});

function formPopup() {
	jQuery('.form-popup').fadeIn();
	jQuery('.close-form-popup').click(function () {
		jQuery('.form-popup').fadeOut();
	});
	jQuery('.form-popup').click(function () {
		jQuery('.form-popup').fadeOut();
	});
	jQuery('.form-popup .popup-main').click(function (event) {
		event.stopPropagation();
	});
}

function formPopupRedirect() {	
	jQuery('.form-popup-redirect').fadeIn();	
	jQuery('.close-form-popup-redirect, .stay-button').click(function () {	
		jQuery('.form-popup-redirect').fadeOut();	
		localStorage.setItem('geo-redirect','true');	
	});	
	jQuery('.form-popup-redirect').click(function () {	
		jQuery('.form-popup-redirect').fadeOut();	
		localStorage.setItem('geo-redirect','true');	
	});	
	jQuery('.form-popup-redirect .popup-main').click(function (event) {	
		event.stopPropagation();	
	});	
}	

function time() {
	
	jQuery('.close-top-bar').click(function () {
		jQuery('.top-bar').slideUp();
		var topTimeBarClosed = getCookie("top_time_bar_closed");
		if (topTimeBarClosed == "") {
			setCookie("top_time_bar_closed", 1, 1);
		}
	});
	var date = new Date();
	var now = date.getTime()
	var endDate = jQuery('.time-box').attr('data-time');
	var end = new Date(endDate.replace(/-/g, "/")).getTime();
	
	
	var intDiff = (parseInt(end) - parseInt(now))/1000;
	var day = 0,
		hour = 0,
		minute = 0,
		second = 0;
	if (intDiff > 0) {
		day = Math.floor(intDiff / (60 * 60 * 24));
		hour = Math.floor(intDiff / (60 * 60)) - (day * 24);
		minute = Math.floor(intDiff / 60) - (day * 24 * 60) - (hour * 60);
		second = Math.floor(intDiff) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60);
		if(day<10){
			day = '0'+day;
		}
		if(hour<10){
			hour = '0'+hour;
		}
		if(minute<10){
			minute = '0'+minute;
		}
		if(second<10){
			second = '0'+second;
		}
	}
	jQuery(".time-box .day-box .value-box").text(day);
	jQuery(".time-box .hour-box .value-box").text(hour); 
	jQuery(".time-box .min-box .value-box").text(minute);
	jQuery(".time-box .sec-box .value-box").text(second);	
	
	timer = window.setInterval(function() {
		var day = 0,
			hour = 0,
			minute = 0,
			second = 0;
		if (intDiff > 0) {
			day = Math.floor(intDiff / (60 * 60 * 24));
			hour = Math.floor(intDiff / (60 * 60)) - (day * 24);
			minute = Math.floor(intDiff / 60) - (day * 24 * 60) - (hour * 60);
			second = Math.floor(intDiff) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60);
			if(day<10){
				day = '0'+day;
			}
			if(hour<10){
				hour = '0'+hour;
			}
			if(minute<10){
				minute = '0'+minute;
			}
			if(second<10){
				second = '0'+second;
			}
		}
		if (Number(hour) == 0 && Number(minute) == 0 & Number(second) == 0){
			clearInterval(timer); 
		}
		jQuery(".time-box .day-box .value-box").text(day);
		jQuery(".time-box .hour-box .value-box").text(hour); 
		jQuery(".time-box .min-box .value-box").text(minute);
		jQuery(".time-box .sec-box .value-box").text(second);	
		intDiff--;
	}, 1000);
}



function faqs() {
	jQuery('.faq-title').click(function () {
		jQuery(this).parent().siblings().find('.faq-content').slideUp(300);
		jQuery(this).parents('.faq-list').siblings().find('.faq-content').slideUp(300);
		jQuery(this).parent().siblings().find('.faq-title').removeClass('open');
		jQuery(this).parents('.faq-list').siblings().find('.faq-title').removeClass('open');
		jQuery(this).siblings().slideToggle(300);
		jQuery(this).toggleClass('open');
	});
}

function videoPopup() {
	jQuery('.play-video-bg').click(function () {
		var videoCode = jQuery(this).find('.data-video').html();
		jQuery('body .popup-video .video-bg').html(videoCode);
		jQuery('.popup-video').fadeIn(200);
	});
	jQuery('.play-video').click(function () {
		var videoCode = jQuery(this).siblings('.data-video').html();
		jQuery('body .popup-video .video-bg').html(videoCode);
		jQuery('.popup-video').fadeIn(200);
	});
	jQuery("body").on("click",".popup-video",function(){
		jQuery('.popup-video').fadeOut(200);
		setTimeout(function () {
		    jQuery('body .popup-video .video-bg').html('');
		}, 200);
	});
	jQuery("body").on("click",".video-bg",function(event){
		event.stopPropagation();
	});
	 
}

function videoSlider() {
	jQuery('.video-slider .slider-box').slick({
		slidesToShow:1,
		slidesToScroll: 1,
		fade: false,
		arrows: true,
		dots: false,
		autoplay: true,
		draggable: false,
		pauseOnHover: false,
		pauseOnFocus: false,
		infinite: true,
		speed: 1000,
		autoplaySpeed: 15000,
		prevArrow: '<button class="prev-btn"><svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="56" y="40" width="56" height="40" rx="20" transform="rotate(-180 56 40)" fill="white"/><path d="M23.6992 14.0998L17.9992 19.7998" stroke="#174349" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round"/><path d="M23.6992 25.5L17.9992 19.8" stroke="#174349" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round"/><path d="M39.5 19.7998L18 19.7998" stroke="#174349" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round"/></svg></button>',
		nextArrow: '<button class="next-btn"><svg width="56" height="40" viewBox="0 0 56 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.000488281" width="56" height="40" rx="20" fill="white"/><path d="M32.3008 25.9002L38.0008 20.2002" stroke="#174349" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round"/><path d="M32.3008 14.5005L38.0008 20.2005" stroke="#174349" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round"/><path d="M16.5 20.2002H38" stroke="#174349" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round"/></svg></button>',
	});
}

function plansSlider() {
	jQuery('.meal-plans-products .products-cols').slick({
		slidesToShow:2,
		slidesToScroll: 1,
		fade: false,
		arrows: false,
		dots: false,
		autoplay: false,
		draggable: false,
		pauseOnHover: false,
		pauseOnFocus: false,
		infinite: false,
		speed: 1000,
		autoplaySpeed: 8000,
		responsive: [
		    {
		        breakpoint: 640,
		        settings: {
					draggable: true,
					swipe:true,
					touchMove:true,
					slidesToShow: 1,
					touchThreshold:100,
		        }
		    }
		]
	});
}

